import { RouterProvider } from 'react-router-dom';

import { createAppRouter } from './routes.jsx';

import { AppProvider } from '@/providers/app-provider.jsx';


const router = createAppRouter();

export default function App() {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
}
